const PAGE_CHANGE = "PAGE_CHANGE";
const RESET_PAGE = "RESET_PAGE";

// Define reducer function
const pageChangeReducer = (state = { page: "home" }, action) => {
  switch (action.type) {
    case PAGE_CHANGE:
      return {
        ...state,
        page: action.payload.page,
      };
    case RESET_PAGE:
      return {
        ...state,
        page: "home",

      };
    default:
      return state;
  }
};

const pageChange = (page) => ({
  type: PAGE_CHANGE,
  payload: {
    page: page,
  },
});

const resetPage = () => {
  localStorage.removeItem("page");
 return {
  type: RESET_PAGE,
}};

export { pageChange, resetPage };
export default pageChangeReducer;
